import { Fancybox } from '@fancyapps/ui';
import initVideo from './video';

(($, Drupal) => {
  const initFancybox = () => {
    const $slides = $('[data-fancybox]');

    if (!$slides.length) {
      return;
    }

    $slides.on('keypress', (e) => {
      const key = e.key || e.keyCode;

      if (key === 13 || key === 'Enter') {
        $slides.trigger('click');
      }
    });

    const carouselOptions = {
      Thumbs: false,
      Toolbar: {
        absolute: true,
        enabled: true,
        display: {
          right: ['close'],
          left: [],
        },
      },
    };

    Fancybox.bind('[data-fancybox]', {
      Carousel: carouselOptions,
      closeButton: false,
      l10n: {
        NEXT: 'Nästa',
        PREV: 'Föregående',
        CLOSE: 'Stäng',
      },
      on: {
        'Carousel.render': (fancybox) => {
          const slide = fancybox.getSlide();
          const videos = $(slide.el).find('.video');
          const container = fancybox.getContainer();

          const $buttons = $(container).find('button.f-button');

          if ($buttons.length > 0) {
            for (let index = 0; index < $buttons.length; index++) {
              const button = $buttons[index];
              const titleAttr = button.getAttribute('title');

              if (titleAttr) {
                button.setAttribute('aria-label', titleAttr);
              }
            }
          }

          if (videos.length > 0) {
            const overlay = $(slide.el).find('.video-center-control__overlay');
            if (overlay) {
              overlay.hide();
            }
            videos.each((i, video) => initVideo(video));
          }
        },
      },
    });
  };

  Drupal.behaviors.mstFancybox = {
    attach: (context) => {
      $('.fancybox-container', context).each((i, element) => initFancybox(element));
    },
  };
})(jQuery, Drupal);
